module.exports = "../fonts/whatsapp_authorize.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp_authorize.svg
// module id = 214
// module chunks = 0